
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Close, FileCopySharp, ViewComfy } from '@material-ui/icons';
import { onlyInteger } from 'hooks/Pipe';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import SweetAlert from 'react-bootstrap-sweetalert';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { currency } from 'hooks/Pipe';
import ModalFull from 'components/Tvendo/Common/ModalFull';

import ReactExport from 'react-data-export';
import moment from 'moment';
import { wsUrl } from 'services/WService';
import { wsGetPdfPromise } from 'services/WService';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const useStyles = makeStyles({
  ...styles,
  closeButton: {
    float: 'right'
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  cardIconTotals: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '13px',
    fontWeight: 'bold'
  },
});

//columnas para llenar la tabla
  const columns = [
    { Header: '#', accessor: 'num', width: 80, excelEnabled: false },
    { Header: 'Cód. producto', accessor: 'ItemCode', width: 135 },
    { Header: 'Nombre producto', accessor: 'ItemName'  },
    { Header: 'Últ. p. compra', accessor: 'last_purchase_price', width: 130 },
    { Header: 'Und. medida', accessor: 'UM', width: 130 },
    { Header: 'Factor', accessor: 'Factor', width: 90 },
    { Header: 'Cantidad', accessor: 'Quantity' },
    { Header: 'Tasa (%)', accessor: 'VatPrcnt' },
    { Header: 'Tot. sin IGV', accessor: 'LineTotal', width: 120 },
    { Header: 'Desc. IGV', accessor: 'VatSum', width: 100 },
    { Header: 'Tot. IGV', accessor: 'GTotal', width: 100 },
    { Header: '', accessor: 'actions', width: 0, excelEnabled: false }
  ];



export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);
  // const [alertState, setAlertState] = useState(null);

  const { id, showNotify, oCDetails, setOCDetails, reload, reloadPurchOrder,ordenCompra, alertState, setAlertState } = props;
  const [model, setOpen] = useModal();

  const totalTableWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0);
  const disabledButton = ordenCompra.state == 'D';
  const quantityField = ordenCompra.state !== 'D' && ordenCompra.state !== 'V';
  const [openPDF, setOpenPDF] = useState(false);
  const [urlPDF, setURLPDF] = useState('');

  const headerExcel = [
    'Cód. producto',
    'Nombre producto',
    'Últ. p. compra',
    'Und. medida',
    'Factor',
    'Cantidad',
    'Tasa (%)',
    'Tot. sin IGV',
    'Desc. IGV',
    'Tot. IGV',
  ];
  const buildDataSet = () => [{
    columns: headerExcel.map((title) => ({ title, width: { wch: title.length + 5 } })),
    data: oCDetails.map(item => [
      { value: item.ItemCode },
      { value: item.ItemName },
      { value: parseFloat(item.last_purchase_price).toFixed(4) },
      { value: item.UM },
      { value: item.Factor },
      { value: item.Quantity ?? '' },
      { value: item.VatPrcnt },
      { value: item.LineTotal },
      { value: item.VatSum },
      { value: item.GTotal },
    ])
  }];
  
  
  const handleChange = (id, field, value) => {
    const index = oCDetails.findIndex((item) => item.id == id);
    if (index === -1) return;

    const updatedItem = {
      ...oCDetails[index],
      [field]: parseFloat(value || 0)
    };

    const price = parseFloat(updatedItem.last_purchase_price || 0);
    const factor = parseFloat(updatedItem.Factor || 1);
    const UM = updatedItem.UM;
    const quantity = parseFloat(updatedItem.Quantity || 0);
    const vatPercent = parseFloat(updatedItem.VatPrcnt || 18);
    const vatDecimal = vatPercent / 100;

    // Cálculos automáticos
    updatedItem.LineTotal = +(price * quantity * factor).toFixed(2);
    updatedItem.VatSum = +(updatedItem.LineTotal * vatDecimal).toFixed(2);
    updatedItem.GTotal = +(updatedItem.LineTotal * (1 + vatDecimal)).toFixed(2);
    updatedItem.UM = UM || 'N/A';

    oCDetails[index] = updatedItem;
    setOCDetails([...oCDetails]);

    return updatedItem;
  };

  async function updatePurchOrderDetail(id, updatedFields) {
    setDataLoading(true);
    let response = await wsUpdate('purch/purchase-order-detalle', id, updatedFields);
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data)
      reload();
    } else {
      reload();
      showNotify(response.message, 'error');
    }
  }

  const Estados = {
    D: 'BORRADOR',
    V: 'Validado',
    C: 'Confirmado',
    S: 'Enviado',
    R: 'Recibido',
    F: 'Finalizado',
  };
  const estadoColors = {
    D: 'warning',
    V: 'info',
    R: 'success',
  };
  const orden_estados = ['D','V','C','S','R','F'];
  
  function getState(current) {
    const idx = orden_estados.indexOf(current);
    if (idx === -1 || idx === orden_estados.length - 1) return null;
    const nextCode = orden_estados[idx + 1];
    return {
      code: nextCode,
      name: Estados[nextCode]
    };
  }
  function confirmChangeOCState(nextState) {
    setAlertState(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Estás seguro de cambiar el estado a "${nextState.name}"?`}
        onConfirm={() => {
          changeOCState(nextState.code);
          setAlertState(null);
        }}
        onCancel={() => setAlertState(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }
  async function changeOCState(stateCode) {
    setDataLoading(true);
    const response = await wsUpdate(`purch/purchase-order/${ordenCompra.id}/update-state`, {
      state: stateCode
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message || 'Estado actualizado');
      reloadPurchOrder();
      reload();
    } else {
      showNotify(response.message || 'Error al actualizar estado', 'error');
    }
  }
  async function ModalVerPDF() {
      setDataLoading(true);
      try {
      const response = await wsGetPdfPromise(`purch/purchase-order/${ordenCompra.id}/ver-pdf`);
        setURLPDF(response);
        setOpenPDF(true);
      } catch (error) {
        showNotify('Error al generar el PDF', 'error');
        setURLPDF(null);
      } finally {
        setDataLoading(false);
      }
    }

  return (
    <>
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={reload}
          purch_order={ordenCompra}
          purch_order_detail={oCDetails}
          purch_order_id={id}
        />
      ) : undefined}
      <ModalFull
        title="Toma de inventario"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
          
        </iframe>
      </ModalFull>

      <Card>
        <CardHeader icon>
          {ordenCompra.state == 'D' ? (
            <AllowedGuard
              permission={ConstantPermissions.PURCH_PURCHASES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
          ) : ordenCompra.state !== 'D' ? (
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
          ) : undefined}

          <h4 className={classes.cardIconTitle}>Listado detallado de orden de compra
          <span style={{ fontSize: '14px' }}>
            <b>{` (${ordenCompra.CardName || ''} - ${ordenCompra.WhsName || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
           <h4 className={classes.cardIconTotals}>{`Total sin igv: S/.${ordenCompra.DocTotal_wo_igv || ''} - Descuento: S/.${ordenCompra.VatSum || ''} - Total: S/.${ordenCompra.DocTotal || ''}`}</h4>
        </CardHeader>
        <CardBody>
          {getState(ordenCompra.state) && (
            <>
              <Button style={{marginRight: '10px'}}
                color={estadoColors[ordenCompra.state] || 'info'}
                onClick={() => confirmChangeOCState(getState(ordenCompra.state))}
              >
                Cambiar estado a {getState(ordenCompra.state).name}
              </Button>
            </>
          )}
          {ordenCompra.state && (
            <>
              <Button
                color="success"
                disabled={ordenCompra.state !== 'R' && ordenCompra.state !== 'F' && ordenCompra.state !== 'S' }
                onClick={() => ModalVerPDF()}
              >
                Mostrar PDF
              </Button>
            </>
          )}
          <div style={{ marginTop: '10px', marginBottom: '-10px' }}>
            <ExcelFile
              element={<Button color="success" size="sm"><ViewComfy/> Excel</Button>}
              filename={`orden_detalle_${moment().format('YYYYMMDD')}`}
            >
              <ExcelSheet dataSet={buildDataSet()} name="Detalle OC" />
            </ExcelFile>
          </div>
          <ReactTable
            // buttonColorSuccess={props.themeContext.buttonColorSuccess}
            exportExcel={false}
            formatDate="DD-MM-YYYY"
            columns={columns}
            defaultWidth={totalTableWidth}
            data={oCDetails.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    {ordenCompra.state == 'D' ? (
                      <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_DELETED}>
                        {/* <ButtonDelete
                          entity="purch/purchase-order-detalle"
                          id={item.id}
                          
                          reload={() => {
                            setDataLoading(true);
                            reload();
                            setDataLoading(false);
                          }}
                        /> */}
                        <Button
                          justIcon
                          round
                          simple
                          onClick={() => {
                            props.confirm('purch/purchase-order-detalle', item.id, reload);
                          }}
                          color={props.themeContext.buttonColorDanger}
                          className="remove"
                        >
                          <Close />
                        </Button>
                      </AllowedGuard>
                     ) : undefined}
                  </div>
                ),
                ItemCode: item.ItemCode,
                ItemName: item.ItemName,
                last_purchase_price: parseFloat(item.last_purchase_price).toFixed(4),
                UM: item.UM,
                Factor: item.Factor,
                Quantity: (
                  <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_UPDATE} component={item.Quantity}>
                    <TextField
                      fullWidth
                      type="number"
                      name="Quantity"
                      margin="normal"
                      disabled={quantityField}
                      value={item.Quantity || ''}
                      onChange={(e) => handleChange(item.id, 'Quantity', e.target.value)}
                      onBlur={(e) => {
                        const updatedItem = handleChange(item.id, 'Quantity', e.target.value);
                        updatePurchOrderDetail(item.id, {
                          Quantity: updatedItem.Quantity,
                          LineTotal: updatedItem.LineTotal,
                          GTotal: updatedItem.GTotal,
                          VatSum: updatedItem.VatSum,
                        });
                      }}
                    />
                  </AllowedGuard>
                ),
                VatPrcnt: item.VatPrcnt,
                LineTotal: (
                  <TextField fullWidth disabled value={currency(item.LineTotal) || ''} margin="normal" />
                ),
                VatSum: (
                  <TextField fullWidth disabled value={currency(item.VatSum) || ''} margin="normal" />
                ),
                GTotal: (
                  <TextField fullWidth disabled value={currency(item.GTotal) || ''} margin="normal" />
                ),
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});

